import { useTheme } from '../hooks/useTheme';
import { Icon } from './Icon';
import { Button as UIButton } from './ui/button';
import { m } from '../paraglide/messages';

/**
 * Square icon button (shadcn Button) that toggles light/dark theme. Both icons
 * are rendered and toggled via the `light-only`/`dark-only` CSS classes (keyed on
 * the pre-paint `data-theme`) rather than branching the JSX on `theme` - that
 * branch would differ between SSR (always light) and the client's first render,
 * tripping a React hydration mismatch.
 */
export const ThemeToggle = () => {
  const { toggle } = useTheme();
  return (
    <UIButton
      type="button"
      variant="line"
      size="icon"
      onClick={toggle}
      aria-label={m.nav_toggle_theme()}
      className="size-8 rounded-8 text-text-2 hover:text-text"
    >
      <Icon name="moon" size={15} className="light-only" />
      <Icon name="sun" size={15} className="dark-only" />
    </UIButton>
  );
};
